export { default as ShopManagerFeeSlot } from './ShopManagerFeeSlot';
